import { render } from "./title-block.vue?vue&type=template&id=0f3ce4c4"
import script from "./title-block.vue?vue&type=script&lang=js"
export * from "./title-block.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__